import { useState } from 'react';

export const useSpaceTypeOptions = () => {
  const [
    isCreateCustomSpaceTypeDialogOpen,
    setIsCreateCustomSpaceTypeDialogOpen,
  ] = useState(false);
  const [
    isEditSpaceTypeNameDialogOpen,
    setIsEditSpaceTypeNameDialogOpen,
  ] = useState(false);

  const [selectedParentSpaceType, setSelectedParentSpaceType] = useState(
    undefined
  );

  const handleCreateCustomSpaceType = () => {
    setIsCreateCustomSpaceTypeDialogOpen(true);
  };

  const onDismissDialog = () => {
    setIsCreateCustomSpaceTypeDialogOpen(false);
  };

  return {
    isCreateCustomSpaceTypeDialogOpen,
    setIsCreateCustomSpaceTypeDialogOpen,
    selectedParentSpaceType,
    setSelectedParentSpaceType,
    handleCreateCustomSpaceType,
    isEditSpaceTypeNameDialogOpen,
    setIsEditSpaceTypeNameDialogOpen,
    onDismissDialog,
  };
};
